import { cleanupLegacyAuthStorage } from './cleanupAuthStorage';

import { clearCsrfTokenCache, clearMemoryAuthTokens, request } from '@/lib/api';
import { clearApiClientCsrfCache } from '@/lib/api/client';
import { announceSessionEnded, onSessionEndedElsewhere } from '@/lib/auth/sessionEndBroadcast';
import { queryClient } from '@/lib/providers/queryClient';
import { clearWorkspaceScopedClientState } from '@/state/workspaceClientState';


/**
 * LOGOUT-1 / LOGOUT-REVOKE-1. POST /auth/logout has no body: the server
 * revokes the session from the refresh cookie. Then drop every client
 * cache and replace the document with /login so Back cannot replay it.
 *
 * SIGNOUT-BROADCAST-1: other open tabs are told, and forget too.
 */
export async function endClientSession(): Promise<void> {
  try {
    await request.post('/auth/logout');
  } catch {
    // The cookie revoke is best-effort. The client still must forget the user.
  }
  announceSessionEnded('signout');
  forgetClientSession();
}

/**
 * Drop every client-side trace of the session and land on sign-in. No server
 * call: used by this tab after logout, and by other tabs when told the
 * session ended (the server side is already done).
 */
export function forgetClientSession(): void {
  clearCsrfTokenCache();
  clearApiClientCsrfCache();
  clearMemoryAuthTokens();
  cleanupLegacyAuthStorage();
  try {
    localStorage.removeItem('zephix.lastOrgId');
    sessionStorage.clear();
  } catch {
    // Private mode can refuse storage.
  }
  clearWorkspaceScopedClientState();
  queryClient.clear();
  window.location.replace('/login');
}

// Every tab listens from boot (AuthContext imports this module at startup).
if (typeof window !== 'undefined') {
  onSessionEndedElsewhere(() => forgetClientSession());
}
